import React, { FC, ChangeEvent } from 'react'
import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'
import { CheckboxProps, Checkbox } from '@mui/material'

const useStyles = makeStyles<void, 'checked'>()((theme: Theme, _params, classes) => ({
  root: {
    color: theme.palette.primary.dark,
    [`&.${classes.checked}`]: {
      color: theme.palette.primary.dark,
    },
  },
  checked: {},
}))

interface MuiCustomCheckbox extends CheckboxProps {
  changeHandler?(event: ChangeEvent): void
}

const GreenCheckbox: FC<MuiCustomCheckbox> = ({ changeHandler, ...props }) => {
  const { classes } = useStyles()

  return (
    <Checkbox
      color='default'
      classes={{ root: classes.root, checked: classes.checked }}
      onChange={changeHandler}
      {...props}
    />
  )
}

export default GreenCheckbox
